import GlVideoEmbedVimeo from '@gl/GlVideoEmbed/GlVideoEmbedVimeo'
import GlVideoEmbedYoutube from '@gl/GlVideoEmbed/GlVideoEmbedYoutube'

export default {
  name: 'GlVideoEmbed',
  functional: true,
  render(createElement, context) {
    const type = context.props.url.includes('vimeo') ? 'vimeo' : 'youtube'
    const player = type === 'youtube' ? GlVideoEmbedYoutube : GlVideoEmbedVimeo
    return createElement(player, context.data)
  },
}
